import { InfoIcon } from '@/app_components/widgets/RatesWidget/InfoIcon';

interface InfoItemProps {
  title: string;
  tooltip?: string;
}

export const InfoItem = ({ title, tooltip }: InfoItemProps) => {
  return (
    <div className='flex grow shrink basis-0 items-center gap-2 uppercase typography-xs'>
      <span>{title}</span>
      {tooltip && <InfoIcon tooltip={tooltip} />}
    </div>
  );
};
